import React from "react";
import Avatar from "../common/Avatar";
import { formatAbsoluteDate } from "../../utils/searchRequestFormat";

// Ownership attribution for an N3 search request (DoD 27). Shows who created it
// (and when), and — once closed — who closed it. created_by/closed_by are the
// backend's {name, avatar} refs; a detached member serializes as "Former member"
// (DoD 29), so this renders whatever the API gives without special-casing.
const RequestAttribution = ({ createdBy, createdAt, closedBy, closedAt, compact = false }) => {
  if (!createdBy && !closedBy) return null;
  const size = compact ? 16 : 18;
  const textCls = compact ? "text-[11px]" : "text-[12px]";
  return (
    <div className={`flex items-center gap-x-3 gap-y-1 flex-wrap ${textCls} text-gray-500`}>
      {createdBy && (
        <span className="inline-flex items-center gap-1.5">
          <Avatar src={createdBy.avatar} fallbackText={createdBy.name} size={size} />
          <span>
            Created by <span className="font-semibold text-[#374151]">{createdBy.name}</span>
            {createdAt && <span className="text-gray-400"> · {formatAbsoluteDate(createdAt)}</span>}
          </span>
        </span>
      )}
      {closedBy && (
        <span className="inline-flex items-center gap-1.5">
          <span className="text-gray-300">•</span>
          <span>
            Closed by <span className="font-semibold text-[#374151]">{closedBy.name}</span>
            {closedAt && <span className="text-gray-400"> · {formatAbsoluteDate(closedAt)}</span>}
          </span>
        </span>
      )}
    </div>
  );
};

export default RequestAttribution;
